export default {
    Brasil: [
        {
            title: "Sobre o grupo",
            links: [
                {
                    title: "Quem Somos",
                    url: "https://www.superbid.net/quem-somos",
                },
                { title: "Imprensa", url: "https://www.superbid.net/imprensa" },
                { title: "Blog", url: "https://blog.superbid.net/" },
                {
                    title: "Trabalhe conosco",
                    url: "https://docs.google.com/forms/d/e/1FAIpQLSfcJeDLlY86C3k5yB6zbMuRWexgb5PMWm5eRBICi1uIgwv5Iw/viewform",
                },
            ],
        },
        {
            title: "Categorias",
            links: [
                {
                    title: "Carros e motos",
                    url: "https://www.superbid.net/categorias/carros-motos?searchType=opened&pageNumber=1&pageSize=30&orderBy=price:desc",
                },
                {
                    title: "Caminhões e ônibus",
                    url: "https://www.superbid.net/categorias/caminhoes-onibus?searchType=opened&pageNumber=1&pageSize=30&orderBy=price:desc",
                },
                {
                    title: "Máquinas pesadas e agrícolas",
                    url: "https://www.superbid.net/categorias/maquinas-pesadas-agricolas?searchType=opened&pageNumber=1&pageSize=30&orderBy=price:desc",
                },
                {
                    title: "Todas as categorias",
                    url: "https://www.superbid.net/todas-categorias/",
                },
            ],
        },
        {
            title: "Eventos",
            links: [
                {
                    title: "Corporativo",
                    url: "https://www.superbid.net/corporativo",
                },
                { title: "Judicial", url: "https://www.superbid.net/judicial" },
                {
                    title: "Beneficente",
                    url: "https://www.superbid.net/categorias/oportunidades/beneficentes?searchType=opened&pageNumber=1&pageSize=30&orderBy=price:desc",
                },
                {
                    title: "Compre já",
                    url: "https://www.superbid.net/todas-ofertas?searchType=opened&filter=auction.modalityId:5;product.productType.description:carros-motos&pageNumber=1&pageSize=30&orderBy=price:desc;visits:desc",
                },
                {
                    title: "Todos os eventos",
                    url: "https://www.superbid.net/todos-eventos/",
                },
            ],
        },
        {
            title: "Precisa de ajuda",
            links: [
                {
                    title: "Como comprar",
                    url: "https://www.superbid.net/como-comprar",
                },
                {
                    title: "Como vender",
                    url: "https://www.superbid.net/quero-vender",
                },
                {
                    title: "Central de ajuda",
                    url: "https://www.superbid.net/ajuda",
                },
                {
                    title: "Canal de ética",
                    url: "https://www.canaldeetica.com.br/gruposuperbid/",
                },
            ],
        },
    ],
    Colombia: [
        //TODO: finalizar preenchimento de links
        {
            title: "Sobre o grupo",
            links: [
                {
                    title: "¿Quiénes somos?",
                    url: "https://www.superbid.com.co/quem-somos",
                },
                {
                    title: "¿Cómo comprar?",
                    url: "https://www.superbid.com.co/como-comprar",
                },
                {
                    title: "Quiero vender",
                    url: "https://www.superbid.com.co/quero-vender",
                },
                {
                    title: "Login",
                    url: "https://accounts.superbid.net/signin?language=es-CO&portal_id=17&_ga=2.197416745.749321605.1647611564-1689122471.1647611564",
                },
                {
                    title: "Registrarse",
                    url: "https://accounts.superbid.net/signup?language=es-CO&portal_id=17&_ga=2.197416745.749321605.1647611564-1689122471.1647611564",
                },
            ],
        },
        {
            title: "Categorias",
            links: [
                { title: "Carros e motos", url: "/quem-somos" },
                { title: "Caminhões e ônibus", url: "#" },
                { title: "Máquinas pesadas e agrícolas", url: "#" },
                { title: "Todas as categorias", url: "#" },
            ],
        },
        {
            title: "Eventos",
            links: [
                { title: "Corporativo", url: "#" },
                { title: "Judicial", url: "#" },
                { title: "Beneficente", url: "#" },
                { title: "Compre já", url: "#" },
                { title: "Todos os eventos", url: "#" },
            ],
        },
        {
            title: "Lojas",
            links: [
                { title: "Santander", url: "#" },
                { title: "Mapfre", url: "#" },
                { title: "Dedalo Leilões", url: "#" },
                { title: "Todas as lojas", url: "#" },
            ],
        },
        {
            title: "Precisa de ajuda",
            links: [
                { title: "Como comprar", url: "#" },
                { title: "Como vender", url: "#" },
                { title: "Central de ajuda", url: "#" },
                { title: "Canal de ética", url: "#" },
            ],
        },
    ],
};
